export class ViewerState {
    pending: boolean = false;
    errorMessage: any = null;
    // The real error behind errorMessage. Only surfaced when debugging is
    // enabled (see diagnostics.ts) — never shown to candidates.
    errorReport: string | null = null;
}